export default __webpack_public_path__ + "static/media/logoNameColor.ad42f439.png";